export default __webpack_public_path__ + "logo-appstore-fr-c57394249f0f7a3e9d51716ab88e5e2c.svg";